App.OrderContentEditBuddyComponent = Em.Component.extend
  classNames: [ 'modal-body-card', 'order' ]

  buddyName: Em.computed.oneWay('buddy.name')

  # Флаг приходит сверху
  canEdit:      false
  editAllowed: Em.computed.alias('canEdit')

  actions:
    contentChanged: ->
      @sendAction('onContentChanged', arguments...)
      false

    changeConfiguration: (item) ->
      @sendAction('onItemConfigEdit', item)
      false


    removeItem: (item) ->
      item.destroyRecord().then =>
        @send('contentChanged')

    # ---
    # Изменить имя участника
    # ---
    changeBuddyName: ->
      return unless @get('editAllowed')
      buddy = @get('buddy')

      nameWas = buddy.get('name')
      nameNow = @get('buddyName')

      if nameWas isnt nameNow
        buddy.set('name', nameNow)
        buddy.save()
      false

    # ---
    # Обработчик "добавить блюдо"
    # ---
    startDishSelect: ->
      return unless @get('editAllowed')
      @sendAction 'onStartDishSelect', @get('buddy')
      false

    # ---
    # Удалить парня из заказа
    # ---
    removeBuddy: (buddy) ->
      return unless @get('editAllowed')
      # todo i18n
      return unless confirm 'Удалить участника заказа?'

      buddy.destroyRecord().then =>
        @sendAction('onContentChanged')
      false

    openPopup: (type) ->
      @get('miniPopups').send('openPopup', type)
      false